// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Srdl","containerItemsCenter":"Skeleton_containerItemsCenter__1gios"};